// Talabalar uchun tayyor o'quv ishlanmalari (amaliy mashg'ulot modullari).
// Har bir modul: maqsad, kutiladigan natijalar, tayanch tushunchalar, qisqa nazariya,
// MTT uchun namunaviy mashg'ulot konspekti, 3 darajali topshiriqlar, ish varag'i,
// o'z-o'zini baholash mezonlari, nazorat savollari va mustaqil ish.

export const taskLevels = {
    reproductive: { label: "Reproduktiv", color: "#3b82f6", hint: "Namuna asosida bajarish" },
    partial: { label: "Qisman izlanuvchan", color: "#f59e0b", hint: "Namunani o'zgartirib qo'llash" },
    creative: { label: "Ijodiy", color: "#10b981", hint: "Mustaqil loyihalash" },
};

export const studentModules = [
    {
        id: "smart",
        methodId: "SMART",
        methodPath: "/method/SMART",
        title: "SMART texnologiyasi asosida mashg'ulot maqsadini loyihalash",
        hours: "2 soat — amaliy mashg'ulot",
        goal: "Talabalarda maktabgacha ta'lim mashg'ulotlari maqsadini aniq, o'lchanadigan va bola rivojlanishiga yo'naltirilgan holda ifodalash ko'nikmasini shakllantirish.",
        outcomes: [
            "SMART mezonlarini sanab beradi va har birini misol bilan izohlaydi",
            "Noto'g'ri ifodalangan maqsadni SMART talablari asosida qayta yozadi",
            "Turli yosh guruhlari uchun mashg'ulot maqsadini mustaqil loyihalaydi",
        ],
        concepts: [
            { term: "Mashg'ulot maqsadi", def: "Mashg'ulot yakunida bolada yuzaga kelishi kutilayotgan aniq o'zgarish (bilim, ko'nikma, munosabat)." },
            { term: "O'lchanadigan natija", def: "Kuzatish orqali tekshirib bo'ladigan harakat: nomlaydi, ajratadi, ko'rsatadi, tuzadi." },
            { term: "Diagnostik maqsad", def: "Bola faoliyati orqali ifodalangan maqsad (\"bolalar ... qila oladi\")." },
        ],
        theory: [
            "Maktabgacha ta'limda ko'p uchraydigan xato — maqsadni tarbiyachi faoliyati orqali yozish: \"bolalarga tushuntirish\", \"tanishtirish\". Bunday maqsadga erishilganini tekshirib bo'lmaydi.",
            "SMART modeli maqsadni bola faoliyati orqali ifodalashni talab qiladi: Specific — aniq, Measurable — o'lchanadigan, Achievable — yoshga mos, Relevant — dastur va bola ehtiyojiga mos, Time-bound — mashg'ulot vaqti bilan cheklangan.",
            "Maqsad yozishda \"biladi\", \"tushunadi\" kabi o'lchab bo'lmaydigan fe'llar o'rniga \"nomlaydi\", \"guruhlaydi\", \"rasm orqali ko'rsatadi\", \"2–3 gapdan iborat hikoya tuzadi\" kabi kuzatiladigan fe'llardan foydalaning.",
        ],
        sample: {
            topic: "Kuz fasli belgilari",
            group: "O'rta guruh (4–5 yosh)",
            duration: "20 daqiqa",
            goal: "Mashg'ulot yakunida bolalar kuz faslining kamida 3 ta belgisini nomlaydi va rasmlar orasidan kuzga oid 4 ta rasmni ajrata oladi.",
            equipment: "Fasllar tasvirlangan rasmlar to'plami, kuzgi barglar savati, \"Kuz\" va \"Yoz\" yozuvli ikki quti.",
            stages: [
                { name: "Motivatsiya", time: "3 daq", teacher: "Savatdagi barglarni ko'rsatib, \"Bu barglar qayerdan keldi?\" deb so'raydi.", children: "Barglarni ushlab ko'radi, taxminlarini aytadi." },
                { name: "Asosiy qism", time: "10 daq", teacher: "Rasmlar orqali kuz belgilarini (barglar sarg'ayadi, qushlar uchib ketadi, kunlar sovuydi) muhokama qiladi.", children: "Rasmlarni ko'radi, belgilarni nomlaydi, o'z kuzatishlarini aytadi." },
                { name: "Amaliy topshiriq", time: "5 daq", teacher: "\"Qutini to'ldir\" o'yinini tashkil etadi.", children: "Rasmlarni \"Kuz\" va \"Yoz\" qutilariga ajratadi." },
                { name: "Yakun (refleksiya)", time: "2 daq", teacher: "\"Bugun kuz haqida nimani bilib oldik?\" deb so'raydi.", children: "Har biri bitta kuz belgisini aytadi." },
            ],
            evaluation: "Tarbiyachi kuzatuv varaqasida har bir bola nechta belgini nomlagani va rasmlarni to'g'ri ajratganini qayd etadi.",
        },
        tasks: [
            { level: "reproductive", text: "Namunadagi maqsadning har bir qismini SMART mezonlariga ajrating: qaysi so'zlar S, M, A, R, T talabiga javob beradi?" },
            { level: "partial", text: "\"Bolalarga uy hayvonlari haqida ma'lumot berish\" maqsadini SMART talablari asosida 5–6 yosh guruhi uchun qayta yozing." },
            { level: "creative", text: "O'zingiz tanlagan mavzuda ikki xil yosh guruhi (3–4 va 6–7 yosh) uchun SMART maqsad yozing va farqini asoslang." },
        ],
        worksheet: [
            { id: "topic", label: "Mashg'ulot mavzusi va yosh guruhi" },
            { id: "s", label: "S — Aniq: bolalar aynan nimani o'rganadi?" },
            { id: "m", label: "M — O'lchanadigan: natija qanday kuzatiladi? (nechta, qanday harakat)" },
            { id: "a", label: "A — Erishish mumkin: nega bu yosh uchun mos?" },
            { id: "r", label: "R — Mos: dastur va bolalar hayotiga qanday bog'liq?" },
            { id: "t", label: "T — Vaqt: qancha vaqt ichida erishiladi?" },
            { id: "final", label: "Yakuniy SMART maqsad (bitta gap)", rows: 3 },
        ],
        rubric: [
            "Maqsad bola faoliyati orqali ifodalangan",
            "Kuzatiladigan fe'l (nomlaydi, ajratadi, tuzadi...) ishlatilgan",
            "Miqdoriy ko'rsatkich bor (nechta belgi, nechta rasm...)",
            "Maqsad yosh xususiyatlariga mos",
            "Vaqt chegarasi ko'rsatilgan",
        ],
        questions: [
            "Nima uchun \"bolalarni tanishtirish\" maqsad sifatida noto'g'ri?",
            "O'lchanadigan maqsad baholashni qanday osonlashtiradi?",
            "Kichik va katta guruh uchun maqsadlar qanday farq qiladi?",
        ],
        homework: "Pedagogik amaliyotda kuzatgan 3 ta mashg'ulot maqsadini yozib oling va ularni SMART mezonlari bo'yicha tahlil qiling.",
    },
    {
        id: "whereto",
        methodId: "WHERETO",
        methodPath: "/method/WHERETO",
        title: "WHERETO modeli asosida mashg'ulot ssenariysini tuzish",
        hours: "2 soat — amaliy mashg'ulot",
        goal: "Talabalarda mashg'ulotni yaxlit tizim sifatida — qiziqtirishdan refleksiyagacha — loyihalash ko'nikmasini rivojlantirish.",
        outcomes: [
            "WHERETO ning 7 elementini izohlaydi",
            "Tayyor mashg'ulot konspektida WHERETO elementlarini topadi",
            "O'zi tanlagan mavzuda WHERETO asosida mashg'ulot ssenariysini tuzadi",
        ],
        concepts: [
            { term: "Hook (qiziqtirish)", def: "Mashg'ulot boshida bolalar diqqatini jalb qiluvchi kutilmagan holat, sirli quti, savol yoki o'yin." },
            { term: "Tailor (moslashtirish)", def: "Topshiriqlarni bolalarning turli imkoniyatlariga moslab tabaqalashtirish." },
            { term: "Rethink (qayta o'ylash)", def: "Bolalar o'rganganini boshqa vaziyatda qo'llab ko'rishi, xulosani qayta ko'rib chiqishi." },
        ],
        theory: [
            "WHERETO — \"teskari loyihalash\" (backward design) g'oyasiga asoslangan model: avval natija belgilanadi, so'ng unga olib boruvchi faoliyat tanlanadi.",
            "W — qayerga boramiz va nima uchun; H — qiziqtirish; E — tajriba orqali bilim bilan ta'minlash; R — qayta o'ylash; E — o'z ishini baholash; T — moslashtirish; O — mantiqiy tartib.",
            "Maktabgacha ta'limda Hook ayniqsa muhim: 4–6 yoshli bolaning ixtiyoriy diqqati 10–15 daqiqa davom etadi, shuning uchun qiziqish mashg'ulot davomida qayta-qayta uyg'otiladi.",
        ],
        sample: {
            topic: "Suv qayerda yashaydi?",
            group: "Katta guruh (5–6 yosh)",
            duration: "25 daqiqa",
            goal: "Bolalar suvning 3 holatini (suyuq, muz, bug') nomlaydi va har biriga hayotdan misol keltiradi.",
            equipment: "Muz bo'laklari, termos (iliq suv), shaffof stakanlar, \"Tomchi\" qo'g'irchog'i.",
            stages: [
                { name: "W + H", time: "3 daq", teacher: "\"Tomchi\" qo'g'irchog'i yo'qolib qolganini aytadi: \"Uni topishga yordam beramizmi?\"", children: "Qiziqib, qidiruvga qo'shiladi." },
                { name: "E — tajriba", time: "10 daq", teacher: "Muz eriyotganini va iliq suvdan bug' chiqayotganini ko'rsatadi.", children: "Kuzatadi, muzni ushlab ko'radi, o'zgarishni aytadi." },
                { name: "R — qayta o'ylash", time: "5 daq", teacher: "\"Qishda ko'lmak nima bo'ladi? Choynakdan nima chiqadi?\"", children: "O'rganganini hayotiy vaziyatga bog'laydi." },
                { name: "T — moslashtirish", time: "4 daq", teacher: "Ba'zi bolalarga rasm juftlash, boshqalariga hikoya tuzish topshirig'ini beradi.", children: "Imkoniyatiga mos topshiriqni bajaradi." },
                { name: "E — baholash", time: "3 daq", teacher: "\"Tomchini topdikmi? U qanday ko'rinishlarda yashaydi?\"", children: "Uchta holatni nomlaydi, o'zini \"quyoshcha\" bilan baholaydi." },
            ],
            evaluation: "Bolalar suv holatlarini nomlashi va misol keltirishi kuzatuv orqali qayd etiladi.",
        },
        tasks: [
            { level: "reproductive", text: "Namunaviy konspektda har bir WHERETO elementi qaysi bosqichda amalga oshganini jadvalga tushiring." },
            { level: "partial", text: "Namunadagi Hook ni boshqa ikki xil usul (sirli quti, musiqa) bilan almashtiring va qaysi biri samaraliroq ekanini asoslang." },
            { level: "creative", text: "\"Yo'l harakati qoidalari\" mavzusida WHERETO ning barcha 7 elementini o'z ichiga olgan mashg'ulot ssenariysini tuzing." },
        ],
        worksheet: [
            { id: "w", label: "W — Mashg'ulot maqsadi va bolalar nima uchun buni o'rganadi?" },
            { id: "h", label: "H — Qanday qiziqtirasiz?" },
            { id: "e1", label: "E — Bolalar qanday tajriba orqali bilim oladi?" },
            { id: "r", label: "R — O'rganganini qanday qayta o'ylashadi?" },
            { id: "e2", label: "E — Bolalar o'z ishini qanday baholaydi?" },
            { id: "t", label: "T — Turli imkoniyatli bolalarga qanday moslashtirasiz?" },
            { id: "o", label: "O — Bosqichlar tartibi (vaqti bilan)", rows: 4 },
        ],
        rubric: [
            "Barcha 7 element mavjud",
            "Hook yosh xususiyatiga mos va qiziqarli",
            "Bolalar faol harakat qiladigan tajriba bor",
            "Tabaqalashtirilgan topshiriq ko'zda tutilgan",
            "Bosqichlar vaqti mashg'ulot davomiyligiga mos",
        ],
        questions: [
            "\"Teskari loyihalash\" an'anaviy rejalashtirishdan nimasi bilan farq qiladi?",
            "Maktabgacha yoshda Hook nima uchun mashg'ulot davomida takrorlanadi?",
            "Bolalar o'z ishini qanday usullarda baholashi mumkin?",
        ],
        homework: "Amaliyotda o'tkaziladigan bitta mashg'ulotingizni WHERETO asosida qayta loyihalang va guruh rahbariga taqdim eting.",
    },
    {
        id: "3i",
        methodId: "3I",
        methodPath: "/method/3I",
        title: "3I metodi: individual yondashuv, hamkorlik va integratsiya",
        hours: "2 soat — amaliy mashg'ulot",
        goal: "Talabalarda bolalarning individual xususiyatlarini hisobga olgan holda hamkorlikdagi va integratsiyalashgan mashg'ulot tashkil etish ko'nikmasini shakllantirish.",
        outcomes: [
            "Individualizatsiya, interaksiya va integratsiya tamoyillarini izohlaydi",
            "Bolalarni imkoniyatiga ko'ra guruhlash usullarini tanlaydi",
            "Bir mashg'ulotda 2–3 ta ta'lim sohasini integratsiyalaydi",
        ],
        concepts: [
            { term: "Individualizatsiya", def: "Har bir bolaning rivojlanish darajasi, qiziqishi va sur'atiga mos topshiriq tanlash." },
            { term: "Interaksiya", def: "Bolalarning juftlik va kichik guruhlarda o'zaro muloqot va hamkorlikda ishlashi." },
            { term: "Integratsiya", def: "Bir mavzuni nutq, matematika, tasviriy faoliyat, musiqa kabi sohalar orqali yaxlit o'rganish." },
        ],
        theory: [
            "3I metodi maktabgacha ta'limning \"bolaga yo'naltirilgan\" tamoyiliga tayanadi: bir xil topshiriq barcha bolalar uchun bir xil samara bermaydi.",
            "Individualizatsiya uchun tarbiyachi oldindan kuzatuv o'tkazadi: qaysi bola tez bajaradi, kimga yordam kerak, kim nimaga qiziqadi.",
            "Interaksiyada \"juftlikda o'yla — bo'lish\", \"kichik yordamchi\", \"aylanma stol\" kabi usullar qo'llanadi. Integratsiya esa mavzuni turli faoliyatlar orqali mustahkamlaydi.",
        ],
        sample: {
            topic: "Sabzavotlar bozori",
            group: "Katta guruh (5–6 yosh)",
            duration: "25 daqiqa",
            goal: "Bolalar 5 ta sabzavotni nomlaydi, ularni rangi bo'yicha guruhlaydi va 5 gacha sanaydi.",
            equipment: "Sabzavot mulyajlari, savatchalar, raqamli kartochkalar, bo'yoqlar.",
            stages: [
                { name: "Kirish", time: "3 daq", teacher: "\"Bozorga\" sayohat taklif qiladi, sotuvchi va xaridor rollarini tanishtiradi.", children: "Rollarni tanlaydi." },
                { name: "Interaksiya", time: "8 daq", teacher: "Juftliklarda \"sotuvchi–xaridor\" o'yinini tashkil etadi.", children: "Sabzavotlarni nomlab \"sotib oladi\", sanaydi." },
                { name: "Individualizatsiya", time: "8 daq", teacher: "Uch darajali topshiriq beradi: rang bo'yicha ajratish / sanab raqam qo'yish / sabzavotdan \"retsept\" tuzish.", children: "O'z darajasidagi topshiriqni bajaradi." },
                { name: "Integratsiya", time: "4 daq", teacher: "\"Sabzavotlar\" qo'shig'ini kuylashni va sevimli sabzavotni chizishni taklif qiladi.", children: "Qo'shiq aytadi, rasm chizadi." },
                { name: "Yakun", time: "2 daq", teacher: "Har bir juftlik \"xaridi\"ni ko'rsatadi.", children: "Natijani taqdim etadi." },
            ],
            evaluation: "Kuzatuv varaqasida har bir bola qaysi darajadagi topshiriqni bajargani va hamkorlikdagi faolligi belgilanadi.",
        },
        tasks: [
            { level: "reproductive", text: "Namunada uchta tamoyilning har biri qaysi bosqichda amalga oshganini aniqlang va izohlang." },
            { level: "partial", text: "Namunadagi uch darajali topshiriqni nutqi sust rivojlangan bola va iqtidorli bola uchun qayta moslashtiring." },
            { level: "creative", text: "\"Mening oilam\" mavzusida nutq, tasviriy faoliyat va matematikani integratsiyalovchi 3I mashg'ulotini loyihalang." },
        ],
        worksheet: [
            { id: "topic", label: "Mavzu va yosh guruhi" },
            { id: "i1", label: "Individualizatsiya: 3 darajali topshiriq (oson / o'rta / murakkab)", rows: 4 },
            { id: "i2", label: "Interaksiya: bolalar qanday juftlik yoki guruhda ishlaydi?" },
            { id: "i3", label: "Integratsiya: qaysi sohalar va qanday bog'lanadi?" },
            { id: "eval", label: "Har bir bola natijasini qanday kuzatasiz?" },
        ],
        rubric: [
            "Topshiriqlar kamida 2 darajada tabaqalashtirilgan",
            "Bolalar juftlik yoki guruhda hamkorlik qiladi",
            "Kamida 2 ta ta'lim sohasi integratsiyalangan",
            "Har bir bola faol ishtirok etadi",
            "Kuzatuv usuli aniq belgilangan",
        ],
        questions: [
            "Individualizatsiya uchun tarbiyachi qanday ma'lumotlarga ega bo'lishi kerak?",
            "Hamkorlikdagi o'yinda tortinchoq bolani qanday faollashtirish mumkin?",
            "Integratsiya va oddiy faoliyat almashinuvi o'rtasidagi farq nima?",
        ],
        homework: "Amaliyot guruhidagi 3 ta bolani bir hafta kuzating va har biri uchun individual rivojlanish tavsiyasini yozing.",
    },
    {
        id: "grasps",
        methodId: "GRASPS",
        methodPath: "/method/GRASPS",
        title: "GRASPS modeli asosida hayotiy vaziyatli topshiriq yaratish",
        hours: "2 soat — amaliy mashg'ulot",
        goal: "Talabalarda bolalar uchun real hayotiy vaziyat va rolga asoslangan amaliy topshiriqlar loyihalash ko'nikmasini rivojlantirish.",
        outcomes: [
            "GRASPS ning 6 komponentini izohlaydi",
            "Syujetli-rolli o'yinni GRASPS tuzilmasida loyihalaydi",
            "Topshiriq uchun bolalar tushunadigan baholash mezonlarini belgilaydi",
        ],
        concepts: [
            { term: "Autentik topshiriq", def: "Real hayotdagi vaziyatga o'xshash, bola o'zini haqiqiy ishtirokchi deb his qiladigan topshiriq." },
            { term: "Rol", def: "Bola topshiriqni bajarishda o'ynaydigan vazifa: shifokor, quruvchi, sotuvchi, ekolog." },
            { term: "Mahsulot", def: "Faoliyat natijasi: chizma, qurilma, sahna ko'rinishi, plakat." },
        ],
        theory: [
            "GRASPS — Goal (maqsad), Role (rol), Audience (kim uchun), Situation (vaziyat), Product (mahsulot), Standards (mezonlar).",
            "Maktabgacha yoshda GRASPS syujetli-rolli o'yin bilan tabiiy uyg'unlashadi: bola rolga kiradi, muammoni hal qiladi va natijani \"mijoz\"ga taqdim etadi.",
            "Standards bolalar uchun sodda bo'lishi kerak: rasmli belgilar (✓ uy mustahkam, ✓ eshigi bor, ✓ chiroyli bezatilgan).",
        ],
        sample: {
            topic: "Quyonchaga uy quramiz",
            group: "O'rta guruh (4–5 yosh)",
            duration: "25 daqiqa",
            goal: "Bolalar konstruktordan eshigi va tomi bor uy quradi va uni 2–3 gap bilan tavsiflaydi.",
            equipment: "Yog'och konstruktor, o'yinchoq quyoncha, rasmli mezon kartochkalari.",
            stages: [
                { name: "Situation", time: "3 daq", teacher: "Quyoncha yomg'irda qolganini, unga uy kerakligini aytadi.", children: "Quyonchaga hamdardlik bildiradi." },
                { name: "Role + Goal", time: "2 daq", teacher: "\"Bugun siz quruvchisiz. Vazifangiz — mustahkam uy qurish.\"", children: "\"Quruvchi\" kaskalarini kiyadi." },
                { name: "Standards", time: "3 daq", teacher: "Rasmli mezonlarni ko'rsatadi: tom, eshik, mustahkamlik.", children: "Mezonlarni takrorlaydi." },
                { name: "Product", time: "12 daq", teacher: "Kichik guruhlar ishini kuzatadi, savollar bilan yo'naltiradi.", children: "Uy quradi, rollarni taqsimlaydi." },
                { name: "Audience", time: "5 daq", teacher: "Quyoncha \"uylarni ko'rib chiqadi\".", children: "Uyini tavsiflaydi, mezonlar bo'yicha tekshiradi." },
            ],
            evaluation: "Har bir guruh mahsuloti rasmli mezonlar bo'yicha birgalikda baholanadi; tarbiyachi nutqiy tavsifni qayd etadi.",
        },
        tasks: [
            { level: "reproductive", text: "Namunadagi topshiriqning 6 ta komponentini GRASPS jadvaliga yozing." },
            { level: "partial", text: "Namunani \"Qushlarga oshxona yasaymiz\" mavzusiga moslab, Role va Audience ni o'zgartiring." },
            { level: "creative", text: "6–7 yosh guruhi uchun \"Kichik ekologlar\" mavzusida GRASPS topshirig'i va rasmli baholash mezonlarini yarating." },
        ],
        worksheet: [
            { id: "g", label: "G — Maqsad" },
            { id: "r", label: "R — Bolalar roli" },
            { id: "a", label: "A — Natija kim uchun (auditoriya)?" },
            { id: "s1", label: "S — Muammoli vaziyat (bolalarga qanday aytiladi?)", rows: 3 },
            { id: "p", label: "P — Mahsulot" },
            { id: "s2", label: "S — Rasmli baholash mezonlari (3 ta)" },
        ],
        rubric: [
            "Vaziyat bolalar hayotiga yaqin va tushunarli",
            "Rol bolalarni qiziqtiradi",
            "Aniq mahsulot ko'zda tutilgan",
            "Mezonlar sodda va rasmli",
            "Natija auditoriyaga taqdim etiladi",
        ],
        questions: [
            "GRASPS va oddiy syujetli-rolli o'yin o'rtasidagi farq nimada?",
            "Nima uchun bolalarga mezonlar oldindan ko'rsatiladi?",
            "Auditoriya rolini kim bajarishi mumkin?",
        ],
        homework: "Ota-onalar ishtirokidagi bitta tadbirni GRASPS asosida loyihalang (auditoriya — ota-onalar).",
    },
    {
        id: "clil",
        methodId: "CLIL",
        methodPath: "/method/CLIL",
        title: "CLIL yondashuvi: mazmun va tilni birga o'rgatish",
        hours: "2 soat — amaliy mashg'ulot",
        goal: "Talabalarda maktabgacha yoshdagi bolalarga mazmun (atrof-olam, matematika) va tilni (ona tili yoki chet tili) integratsiyalashgan holda o'rgatish ko'nikmasini shakllantirish.",
        outcomes: [
            "CLIL ning 4C tamoyilini izohlaydi",
            "Mashg'ulot uchun mazmun va til maqsadlarini alohida belgilaydi",
            "Ko'rgazmali qo'llab-quvvatlash (scaffolding) vositalarini tanlaydi",
        ],
        concepts: [
            { term: "4C", def: "Content (mazmun), Communication (muloqot), Cognition (tafakkur), Culture (madaniyat)." },
            { term: "Scaffolding", def: "Bolaga til to'sig'ini yengishda yordam beruvchi vositalar: rasm, imo-ishora, namuna gap." },
            { term: "Til maqsadi", def: "Mashg'ulotda bola o'zlashtiradigan so'zlar va gap qoliplari." },
        ],
        theory: [
            "CLIL da til — maqsadning o'zi emas, balki mazmunni o'rganish vositasi. Bola \"rang\" so'zini rangni o'rganayotganda tabiiy ravishda o'zlashtiradi.",
            "Har bir CLIL mashg'uloti ikki maqsadga ega: mazmun maqsadi (masalan, hayvonlar qayerda yashaydi) va til maqsadi (masalan, \"... o'rmonda yashaydi\" gap qolipi).",
            "Maktabgacha yoshda CLIL ko'proq qo'shiq, harakat (TPR — jismoniy javob), rasm va o'yin orqali amalga oshiriladi.",
        ],
        sample: {
            topic: "Ranglar / Colors",
            group: "Katta guruh (5–6 yosh)",
            duration: "20 daqiqa",
            goal: "Mazmun: bolalar 4 ta asosiy rangni ajratadi. Til: \"It is red / Bu qizil\" qolipida rangni nomlaydi.",
            equipment: "Rangli koptoklar, rangli qog'oz doiralar, \"Colors\" qo'shig'i audiosi.",
            stages: [
                { name: "Qo'shiq (Communication)", time: "3 daq", teacher: "\"Colors\" qo'shig'ini harakatlar bilan kuylaydi.", children: "Takrorlaydi, harakat qiladi." },
                { name: "Mazmun (Content)", time: "6 daq", teacher: "Koptoklarni ko'rsatib ikki tilda nomlaydi.", children: "Rangni ko'rsatadi, nomlaydi." },
                { name: "O'yin (Cognition)", time: "7 daq", teacher: "\"Rangini top\" o'yini: \"Find something red!\"", children: "Xonadan shu rangdagi buyumni topib keladi." },
                { name: "Madaniyat (Culture)", time: "2 daq", teacher: "O'zbek milliy matolaridagi ranglarni ko'rsatadi.", children: "Tanish ranglarni topadi." },
                { name: "Yakun", time: "2 daq", teacher: "\"What color is it?\"", children: "Javob beradi." },
            ],
            evaluation: "Bolalarning rangni ajratishi (mazmun) va qolip asosida nomlashi (til) alohida qayd etiladi.",
        },
        tasks: [
            { level: "reproductive", text: "Namunadagi har bir bosqich 4C ning qaysi tamoyiliga mos kelishini aniqlang." },
            { level: "partial", text: "Namunani \"Mevalar\" mavzusiga moslang va yangi til qolipini belgilang." },
            { level: "creative", text: "Rus yoki ingliz tilida \"Hayvonlar va ularning uylari\" mavzusida CLIL mashg'ulotini loyihalang; scaffolding vositalarini ko'rsating." },
        ],
        worksheet: [
            { id: "content", label: "Mazmun maqsadi" },
            { id: "lang", label: "Til maqsadi (so'zlar va gap qolipi)" },
            { id: "cog", label: "Tafakkurni rivojlantiruvchi topshiriq" },
            { id: "cult", label: "Madaniyat komponenti" },
            { id: "scaf", label: "Scaffolding vositalari (rasm, imo-ishora, qo'shiq...)" },
        ],
        rubric: [
            "Mazmun va til maqsadi alohida belgilangan",
            "4C ning barcha tamoyillari aks etgan",
            "Til yuklamasi yoshga mos (3–5 ta yangi so'z)",
            "Ko'rgazmali qo'llab-quvvatlash yetarli",
            "Bolalar harakat orqali javob beradi",
        ],
        questions: [
            "CLIL an'anaviy chet tili mashg'ulotidan nimasi bilan farq qiladi?",
            "Ikki tilli guruhda CLIL qanday yordam beradi?",
            "Maktabgacha yoshda yangi so'zlar soni nechta bo'lishi maqbul?",
        ],
        homework: "Bitta bolalar qo'shig'ini tanlang va uni CLIL mashg'ulotining kirish qismi sifatida qanday ishlatishni rejalashtiring.",
    },
    {
        id: "sq3r",
        methodId: "SQ3R",
        methodPath: "/method/SQ3R",
        title: "SQ3R asosida badiiy asar (ertak) bilan ishlash",
        hours: "2 soat — amaliy mashg'ulot",
        goal: "Talabalarda SQ3R strategiyasini maktabgacha yoshga moslab, rasmli kitob va ertaklar bilan ishlashda qo'llash ko'nikmasini shakllantirish; shuningdek, talabaning o'zi ilmiy-metodik adabiyot bilan ishlash ko'nikmasini rivojlantirish.",
        outcomes: [
            "SQ3R bosqichlarini o'z o'qish faoliyatida qo'llaydi",
            "SQ3R ni bolalar uchun rasmli kitob bilan ishlashga moslaydi",
            "Ertak bo'yicha bolalar uchun savollar tizimini tuzadi",
        ],
        concepts: [
            { term: "Survey (ko'zdan kechirish)", def: "Bolalar bilan kitob muqovasi va rasmlarini ko'rib, mazmunini taxmin qilish." },
            { term: "Recite (aytib berish)", def: "Bola eshitganini o'z so'zlari bilan qayta hikoya qilishi." },
            { term: "Savollar tizimi", def: "Oddiy (kim? nima?) savollardan murakkab (nima uchun? sen bo'lganingda?) savollarga o'tish." },
        ],
        theory: [
            "SQ3R — Survey, Question, Read, Recite, Review. Bu strategiya avval talabaning o'zi uchun: darslik va maqolalarni samarali o'qishga yordam beradi.",
            "Maktabgacha yoshda bolalar o'zi o'qimaydi, shuning uchun \"Read\" bosqichida tarbiyachi ifodali o'qiydi, bolalar esa tinglab, rasmlarni kuzatadi.",
            "Muhimi — savollar: bola tinglashdan oldin savolga ega bo'lsa, u diqqat bilan tinglaydi va mazmunni yaxshi eslab qoladi.",
        ],
        sample: {
            topic: "\"Sholg'om\" ertagi",
            group: "Kichik guruh (3–4 yosh)",
            duration: "15 daqiqa",
            goal: "Bolalar ertak qahramonlarini tartib bilan nomlaydi va 2–3 gap bilan voqeani aytib beradi.",
            equipment: "Rasmli kitob, qahramonlar figuralari (stol teatri).",
            stages: [
                { name: "Survey", time: "2 daq", teacher: "Muqovani ko'rsatib: \"Bu yerda kimlarni ko'ryapsiz? Nima bo'larkin?\"", children: "Rasmlarni ko'rib, taxmin qiladi." },
                { name: "Question", time: "2 daq", teacher: "\"Bobo sholg'omni o'zi sug'ura oladimi? Kim yordam beradi?\"", children: "Savolni eslab qoladi." },
                { name: "Read", time: "5 daq", teacher: "Ertakni ifodali o'qiydi, figuralarni ko'rsatadi.", children: "Tinglaydi, takroriy so'zlarni birga aytadi." },
                { name: "Recite", time: "4 daq", teacher: "Figuralarni bolalarga beradi: \"Kim keyin keldi?\"", children: "Qahramonlarni tartib bilan joylashtiradi, aytib beradi." },
                { name: "Review", time: "2 daq", teacher: "\"Ertak bizga nimani o'rgatdi?\"", children: "\"Birga bo'lsak kuchli bo'lamiz\" degan xulosaga keladi." },
            ],
            evaluation: "Qahramonlar ketma-ketligini to'g'ri tiklagan va voqeani aytib bergan bolalar qayd etiladi.",
        },
        tasks: [
            { level: "reproductive", text: "Ushbu modul nazariyasini SQ3R usulida o'qing: har bir bosqichda nima qilganingizni yozing." },
            { level: "partial", text: "\"Bo'g'irsoq\" ertagi uchun 5–6 yosh guruhiga SQ3R ning har bir bosqichiga savollar tuzing." },
            { level: "creative", text: "O'zbek xalq ertagini tanlang va SQ3R asosida stol teatri elementli mashg'ulot loyihalang." },
        ],
        worksheet: [
            { id: "book", label: "Asar nomi va yosh guruhi" },
            { id: "s", label: "Survey: bolalarga muqova bo'yicha qanday savol berasiz?" },
            { id: "q", label: "Question: tinglashdan oldingi asosiy savol" },
            { id: "r1", label: "Read: o'qish usuli va ko'rgazma" },
            { id: "r2", label: "Recite: bolalar qanday aytib beradi?" },
            { id: "r3", label: "Review: xulosa savoli" },
        ],
        rubric: [
            "Tinglashdan oldin savol qo'yilgan",
            "Savollar oddiydan murakkabga qarab tuzilgan",
            "Bolalar faol aytib berish imkoniga ega",
            "Ko'rgazma (rasm, figura) qo'llangan",
            "Asar tarbiyaviy xulosasi bilan yakunlangan",
        ],
        questions: [
            "Nima uchun tinglashdan oldin savol qo'yish samarali?",
            "Kichik va katta guruhda Recite bosqichi qanday farq qiladi?",
            "SQ3R talabaning o'z o'qish faoliyatiga qanday yordam beradi?",
        ],
        homework: "Maktabgacha pedagogika bo'yicha bitta ilmiy maqolani SQ3R usulida o'qing va 5 ta asosiy fikrni yozing.",
    },
    {
        id: "qosh_daraxt",
        methodId: "qosh_daraxt",
        methodPath: "/method/qosh_daraxt",
        title: "\"Qo'sh daraxt\" grafik organayzeri bilan bilimni tizimlashtirish",
        hours: "2 soat — amaliy mashg'ulot",
        goal: "Talabalarda grafik organayzerlar yordamida bolalarning bilimini tizimlashtirish, taqqoslash va umumlashtirish ko'nikmasini rivojlantirish.",
        outcomes: [
            "\"Qo'sh daraxt\" tuzilishini va qo'llash shartlarini izohlaydi",
            "Ikki tushunchani taqqoslash uchun organayzer tuzadi",
            "Organayzerni bolalar bilan birgalikda to'ldirish jarayonini tashkil etadi",
        ],
        concepts: [
            { term: "Grafik organayzer", def: "Bilimlar o'rtasidagi bog'liqlikni ko'rgazmali tasvirlovchi sxema." },
            { term: "Taqqoslash", def: "Ikki narsaning o'xshash va farqli belgilarini aniqlash." },
            { term: "Umumlashtirish", def: "Bir nechta belgilar asosida umumiy xulosa chiqarish." },
        ],
        theory: [
            "\"Qo'sh daraxt\" — ikki tushunchani (masalan, uy hayvonlari va yovvoyi hayvonlar) ikki daraxt shaklida taqqoslash: tanasida tushuncha, shoxlarida belgilar, ildizida umumiy jihatlar.",
            "Maktabgacha yoshda organayzer rasmlar bilan to'ldiriladi: bolalar rasm kartochkalarini mos shoxga yopishtiradi.",
            "Organayzer bolaning ko'rgazmali-obrazli tafakkuriga mos keladi va mantiqiy fikrlashning dastlabki ko'nikmalarini shakllantiradi.",
        ],
        sample: {
            topic: "Uy hayvonlari va yovvoyi hayvonlar",
            group: "Katta guruh (5–6 yosh)",
            duration: "25 daqiqa",
            goal: "Bolalar 6 ta hayvonni uy va yovvoyi guruhlarga ajratadi va har bir guruhning 2 ta belgisini aytadi.",
            equipment: "Doskada ikki daraxt rasmi, hayvon rasmli kartochkalar, yopishqoq lenta.",
            stages: [
                { name: "Kirish", time: "3 daq", teacher: "Topishmoq aytadi: \"Uyda yashaydi, sut beradi...\"", children: "Topishmoqni topadi." },
                { name: "Organayzer bilan tanishuv", time: "4 daq", teacher: "Ikki daraxtni ko'rsatadi: biri ferma yonida, biri o'rmonda.", children: "Daraxtlar nima uchun turli joyda ekanini taxmin qiladi." },
                { name: "To'ldirish", time: "10 daq", teacher: "Bolalarni navbatma-navbat chaqiradi, \"Nega bu yerga?\" deb so'raydi.", children: "Kartochkani mos daraxtga yopishtiradi, sababini aytadi." },
                { name: "Ildiz (umumiylik)", time: "5 daq", teacher: "\"Bu hayvonlarning hammasida nima bor?\"", children: "Umumiy belgilarni topadi: oyog'i bor, ovqatlanadi." },
                { name: "Yakun", time: "3 daq", teacher: "Daraxtlarni birga \"o'qiydi\".", children: "Xulosa qiladi." },
            ],
            evaluation: "Har bir bolaning kartochkani to'g'ri joylashtirgani va sababini asoslagani qayd etiladi.",
        },
        tasks: [
            { level: "reproductive", text: "Namunadagi organayzerni qog'ozda chizing va qaysi qismi taqqoslash, qaysi qismi umumlashtirish uchun ekanini belgilang." },
            { level: "partial", text: "\"Qish va yoz\" mavzusi uchun qo'sh daraxt tuzing va 4–5 yosh guruhiga moslang." },
            { level: "creative", text: "Ikki xorijiy tajribani (masalan, Koreya va Germaniya MTT tizimi) qo'sh daraxt organayzerida o'zingiz uchun taqqoslang." },
        ],
        worksheet: [
            { id: "topic", label: "Taqqoslanadigan ikki tushuncha" },
            { id: "left", label: "1-daraxt shoxlari (belgilar)" },
            { id: "right", label: "2-daraxt shoxlari (belgilar)" },
            { id: "root", label: "Ildiz — umumiy jihatlar" },
            { id: "conclusion", label: "Bolalar chiqaradigan xulosa" },
        ],
        rubric: [
            "Taqqoslanadigan tushunchalar yoshga mos",
            "Belgilar rasm bilan ifodalangan",
            "Umumiy va farqli jihatlar ajratilgan",
            "Har bir bola organayzerni to'ldirishda ishtirok etadi",
            "Bolalar tanlovini asoslaydi",
        ],
        questions: [
            "Grafik organayzer bolalarning qaysi tafakkur turiga mos keladi?",
            "\"Qo'sh daraxt\" ni yana qaysi mavzularda qo'llash mumkin?",
            "Organayzer bilan ishlashda bola xato qilsa, qanday yo'l tutasiz?",
        ],
        homework: "Mutaxassislik fanlaridan biridagi ikki tushunchani qo'sh daraxt orqali taqqoslang va seminarda taqdim eting.",
    },
];
